import { useMemo, type CSSProperties } from 'react';
import type { BoxProps } from '@shopify/polaris';

import { Box } from '@shopify/polaris';

export type SpaceScale =
  | '0'
  | '025'
  | '050'
  | '100'
  | '150'
  | '200'
  | '300'
  | '400'
  | '500'
  | '600'
  | '800'
  | '1000'
  | '1200'
  | '1600'
  | '2000'
  | '2400'
  | '2800'
  | '3200';

export interface GBlockCenterProps extends Omit<
  BoxProps,
  'insetInlineStart' | 'insetInlineEnd' | 'insetBlockStart' | 'insetBlockEnd'
> {
  height?: string;
  align?: 'center' | 'start' | 'end';
  inlineAlign?: 'center' | 'start' | 'end';
  display?: CSSProperties['display'];
  insetInlineStart?: SpaceScale;
  insetInlineEnd?: SpaceScale;
  insetBlockStart?: SpaceScale;
  insetBlockEnd?: SpaceScale;
}

export const GBlockCenter = ({
  height,
  align,
  inlineAlign,
  display,
  ...props
}: GBlockCenterProps) => {
  const stickyStyle = useMemo<CSSProperties>(() => {
    if (props.position !== 'sticky') return {};

    const style: CSSProperties = {
      position: 'sticky',
    };
    if (props.insetInlineStart) style.insetInlineStart = Number(props.insetInlineStart) * 4;
    if (props.insetInlineEnd) style.insetInlineEnd = Number(props.insetInlineEnd) * 4;
    if (props.insetBlockStart) style.insetBlockStart = Number(props.insetBlockStart) * 4;
    if (props.insetBlockEnd) style.insetBlockEnd = Number(props.insetBlockEnd) * 4;
    return style;
  }, [
    props.position,
    props.insetInlineStart,
    props.insetInlineEnd,
    props.insetBlockStart,
    props.insetBlockEnd,
  ]);

  return (
    <div
      className="Polaris-GBlockCenter"
      style={
        {
          ...stickyStyle,
          '--gp-block-center-height': height,
          '--gp-block-center-display': display,
          '--gp-block-center-align': align,
          '--gp-block-center-inline-align': inlineAlign,
          '--gp-block-center-overflow-x': props.overflowX,
          '--gp-block-center-overflow-y': props.overflowY,
        } as CSSProperties
      }
    >
      <Box {...props} />
    </div>
  );
};
